// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kcTet","index":"styles_index__38_Z3"};